import { AppboyAnalyticsHandler } from './AppboyAnalyticsHandler';
import { BIEventsAnalyticsHandler } from './BIEventsAnalyticsHandler';
import { FirebaseAnalyticsHandler } from './FirebaseAnalyticsHandler';
import { MixpanelAnalyticsHandler } from './MixpanelAnalyticsHandler';

export class AnalyticsClient {
  public appboy: AppboyAnalyticsHandler;
  public firebase: FirebaseAnalyticsHandler;
  public BIEvent: BIEventsAnalyticsHandler;
  public Mixpanel: MixpanelAnalyticsHandler;

  constructor(
    appboy: AppboyAnalyticsHandler,
    firebase: FirebaseAnalyticsHandler,
    BIEvent: BIEventsAnalyticsHandler,
    mixpanel: MixpanelAnalyticsHandler,
  ) {
    this.appboy = appboy;
    this.firebase = firebase;
    this.BIEvent = BIEvent;
    this.Mixpanel = mixpanel;
  }
}
